<template>
<v-card>
    <div v-if="laravelErrors.active" class="text-xs-center pa-3">
        <v-chip v-for="(msg,key) in laravelErrors.messages" :key="key" label color="red" text-color="white">
            {{ msg[0] }}
        </v-chip>
    </div>
    <v-card-text>
        <v-select :items="semesters" :item-text="semesterDisplay" item-value="id" label="Semester" v-model="semester_id"></v-select>
        <v-text-field name="section" label="Class section number" v-model="section"></v-text-field>
        <v-checkbox label="Copy Roster" v-model="roster"></v-checkbox>
    </v-card-text>
    <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="close">Close</v-btn>
        <v-btn color="success" @click="getCourseData">Copy</v-btn>
    </v-card-actions>
</v-card>
</template>

<script>
export default {
    props: {
        active: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            semester_id: '',
            section: '',
            roster: false
        }
    },
    computed: {
        semesters() {
            return this.$store.getters.semestersRouterFormat
        },
        laravelErrors() {
            return this.$store.state.errorModule.validation
        }
    },
    methods: {
        semesterDisplay: item => item.name,
        getCourseData() {
            this.$store.commit('clearErrors')
            let payload = {
                semester_id: this.semester_id,
                section: this.section,
                copyRoster: this.roster ? 1 : 0 // I think passing this value as a URL param converts type to a string, so can't use regular boolean value
            }
            this.$store.dispatch('copyCourse', payload)
                .then(() => this.$emit('success'))
                .catch(() => {}) // errors are handled by error Module
        },
        close() {
            this.$emit('close') // inlining this on click event causes render error
        }
    },
    watch: {
        'active'(value) {
            if (!value) {
                this.section = ''
                this.semester_id = ''
                this.roster = false
                this.$store.commit('clearErrors')
            }
        }
    }
}
</script>
